import { storyblokEditable } from "@storyblok/react/rsc";

import { ListItem } from "@/components/layout/ListItem";
import type { TextBlockItemStoryblok } from "@/component-types-sb";
import type { ListItemIconName } from "@/components/icons";

type TextBlockItemProps = {
  blok: TextBlockItemStoryblok;
};

const TextBlockItem = ({ blok }: TextBlockItemProps) => {
  return (
    <ListItem
      variant="tall"
      icon={blok.icon as ListItemIconName}
      customIconUrl={blok.custom_icon?.filename}
      title={blok.title}
      subtitle={blok.subtitle}
      {...storyblokEditable(blok)}
    />
  );
};

export default TextBlockItem;
